import type { Node } from 'react'
import { Component } from 'react'
import { withRouter } from 'react-router-dom'

type Props = {
    match: Object,
    location: Object,
    history: Object,
    children: Node
}

class ScrollToTopComponent extends Component<Props> {
    componentDidUpdate(prevProps) {
        if (this.props.location !== prevProps.location) {
            /* HOTFIX: BE-372 => Scroll to top when route change */
            setTimeout(() => {
                window.scrollTo(0, 0)
            }, 0)
        }
    }

    render() {
        return this.props.children
    }
}

const ScrollToTop = withRouter(ScrollToTopComponent)

export { ScrollToTop }
